module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/flag-black.66de8cf4.svg";